
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export function initLanguage() {
    i18next.init({
        debug: false,
        lng: 'nl',
        resources: {
            en: {
                translation: {
                    layerOverview: 'Layer overview',
                    activeLayers: 'Active layers',
                    sharePage: 'Share page',
                    openDataPortal: 'Open data portal',
                    openFullScreen: 'Open in full screen',
                    openHelp: 'Help',
                    openHome: 'Back to home',
                    openInfo: 'View information about this website',
                    openLayerMenu: 'Open the layers menu',
                    openLogIn: 'Log in with a user account',
                    openPrint: 'Create PDF printout',
                    searchAdress: 'Search address...',
                    search: 'Search',
                    searchParcel: 'Search parcel...',
                    noInfoFound: 'No info found',
                    clickObject: 'Click on an object to retrieve data',
                    searchLayer: 'Search layers...',
                    logIn: 'Log in',
                    openRightMouseButton: 'Open in another application',
                    addNewDataSet: 'Add new data set',
                    characteristics: 'Characteristics',
                    information: 'Information',
                    legend: 'Legend',
                    tools: 'Tools',
                    filter: 'Filter',
                    from: 'from',
                    polygon: 'polygon',
                    rectangle: 'rectangle',
                    square: 'square',
                    circle: 'circle',
                    fromMap: 'from Map',
                    object: 'object',
                    drawPolygon: 'Draw a polygon. Double click to close.',
                    drawLineString: 'Draw a line. Double click to close.',
                    draw: 'Draw',
                    measure: 'Measure',
                    mutation: 'Mutation',
                    '3dFunctions': '3D functions',
                    settings: 'Settings',
                    notifications: 'Notifications',
                    view: 'Bekijken'
                }
            },
            nl: {
                translation: {
                    layerOverview: 'Lagen',
                    activeLayers: 'Actief',
                    sharePage: 'Deel pagina',
                    openDataPortal: 'Open het dataportaal',
                    openFullScreen: 'Open volledig scherm',
                    openHelp: 'Help',
                    openHome: 'Terug naar startscherm',
                    openInfo: 'Bekijk informatie over deze website',
                    openLayerMenu: 'Open/sluit de catalogus',
                    openLogIn: 'Log in met een gebruikersaccount',
                    openPrint: 'Afdruk maken',
                    searchAdress: 'Zoeken op adres...',
                    searchParcel: 'Zoeken op perceel...',
                    noInfoFound: 'Geen data gevonden',
                    clickObject: 'Klik op een object data op te halen',
                    searchLayer: 'Zoek op lagen...',
                    search: 'Zoeken',
                    logIn: 'Inloggen',
                    openRightMouseButton: 'Doorstart naar andere applicatie',
                    addNewDataSet: 'Nieuwe dataset toevoegen',
                    characteristics: 'Kenmerken',
                    information: 'Informatie',
                    legend: 'Legenda',
                    tools: 'Tekenen en meten',
                    filter: 'Filter',
                    from: 'van',
                    polygon: 'vlak',
                    rectangle: 'rechthoek',
                    circle: 'cirkel',
                    object: 'object',
                    square: 'vierkant',
                    drawPolygon: 'Teken een vlak. Dubbelklik om af te sluiten.',
                    drawCircle: 'Teken een cirkel. Klik in de kaart om het te plaatsen.',
                    drawRectangle: 'Teken een rechthoek. Dubbelklik om af te sluiten.',
                    drawSquare: 'Teken een vierkant. Dubbelklik om af te sluiten.',
                    drawLineString: 'Teken een lijn. Dubbelklik om af te sluiten.',
                    drawText: 'Vul een tekst in. Klik in de kaart om het te plaatsen.',
                    drawPoint: 'Teken een punt. Klik in de kaart om het te plaatsen.',
                    text: 'tekst',
                    draw: 'Tekenen',
                    LineString: 'Lijn',
                    point: 'Punt',
                    measure: 'Meten',
                    mutation: 'Muteren',
                    fromMap: 'Uit kaart',
                    drawFromMap: 'Neem het vlak uit de kaart over',
                    '3dFunctions': '3D functies',
                    settings: 'Instellingen',
                    notifications: 'Mededelingen',
                    view: 'Bekijken',
                    drawView: 'Klik op een getekend object om de data te bekijken'
                }
            },
            pl: {
                translation: {
                    layerOverview: 'Przegląd warstw',
                    activeLayers: 'Aktywne warstwy'
                }
            }
        }
    });

    updateLanguage()
}

export function getActiveLanguage() {
    return i18next.language
}

export function changeLanguage(lng) {
    i18next.changeLanguage(lng, (err, t) => {
        updateLanguage()
    });
}

export function updateLanguage() {
    document.querySelectorAll('layout-language').forEach(function (element) {
        element.innerHTML = i18next.t(element.dataset.key)
    })

    // if(parseInt(window.activeAdressSearchType) === 1) {
    //     document.getElementsByClassName('iptSearchAddress')[0].placeholder = i18next.t('searchParcel')
    // } else {
    //     document.getElementsByClassName('iptSearchAddress')[0].placeholder = i18next.t('searchAdress')
    // }

    const iptSearchLayer = document.getElementsByClassName('iptSearchLayer')[0]
    if(iptSearchLayer !== undefined) {
        iptSearchLayer.placeholder = i18next.t('searchLayer')
    }

}
